var React = require('react');

function HealthcheckInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","fill":"currentColor","stroke":"currentColor"},React.createElement("polyline",{"points":"1 12 6 12 9 4 15 20 18 12 23 12","fill":"none","stroke":"currentColor","strokeMiterlimit":"10"})));
}

HealthcheckInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = HealthcheckInline;

HealthcheckInline.default = HealthcheckInline;
